
export class OrderDto {

    orderId;
    order;
    orderName;
    orderNumber;
    contracts;
    control;
 }